// extracted by mini-css-extract-plugin
module.exports = {"content":"genericStyle-module--content--1Wpzz"};